import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, defer, filter, finalize, firstValueFrom, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpApiService } from 'src/app/shared/services/http.api.service';
import { ApplicationScheme } from 'src/app/shared/models/pwc/application-scheme';

@Injectable({
  providedIn: 'root'
})
export class EEAGapApiService extends HttpApiService {
  override apiUrl: string = environment.BAMS_Api_URL;

  getApplicationSchemesByProjectAndCompartment(pProjectPk: number, pCompartmentPk: number): Observable<any[]> {
    return this
      .get(`api/applicationSchemesByProjectAndCompartment/${pProjectPk}/${pCompartmentPk}`)
      .pipe(map((data: any) => data.Value));
  }

  getApplicationSchemesByProjectWithAllCompartments(pProjectPk: number): Observable<any[]> {
    return this
      .get(`api/GetApplicationSchemesByProjectWithAllCompartments/${pProjectPk}`)
      .pipe(map((data: any) => data.Value));
  }

  getApplicationSchemesByProjectAndCompartmentPWC(pProjectPk: number, pCompartmentPk: number): Observable<ApplicationScheme[]> {
    return this
      .get(`api/applicationSchemesByProjectAndCompartmentPWC/${pProjectPk}/${pCompartmentPk}`)
      .pipe(map((data: any) => data.Value));
  }

  private readonly pendingSaves = new BehaviorSubject<number>(0);

  save(pData: any): Observable<any> {
    const body = JSON.stringify(pData);
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    let applicationScheme = `api/applicationSchemes`;
    return defer(() => {
      this.pendingSaves.next(this.pendingSaves.value + 1);
      return this.put(applicationScheme, body, headers).pipe(
        map((data: any) => data.Value),
        finalize(() => this.pendingSaves.next(this.pendingSaves.value - 1)));
    });
  }

  waitForPendingSaves(): Promise<void> {
    return firstValueFrom(this.pendingSaves.pipe(filter(count => count === 0), map(() => undefined)));
  }

  getAndCopyApplicationSchemesByProjectAndCompartment(pProjectPk?: number, projectNew?: number): Observable<number> {
    return this
      .get(`api/GetAndCopyApplicationSchemesByProjectAndCompartment/${pProjectPk}/${projectNew}`)
      .pipe(map((data: any) => data.Value));
  }

  savePWC(pData: any): Observable<any> {
    const body = JSON.stringify(pData);
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    let applicationScheme = `api/applicationSchemesPWC`;
    return this
      .put(applicationScheme, body, headers).
      pipe(map((data: any) => data.Value));
  }

  DeleteDetailsPWC(pk: number): Observable<any> {
    let applicationScheme = `api/applicationSchemesXApplication/${pk}`;
    return this
      .delete(applicationScheme).
      pipe(map((data: any) => data.Value));
  }

  getScenarioFilesPaths(statesXCrops: any): Observable<any> {
    return this
      .put(`api/PWC/GetScenarioFilesPaths`, statesXCrops)
      .pipe(map((data: any) => data.Value));
  }

  updateAppSchemeCropPkFromCropInterceptionPk(applicationSchemePks: number[]): Observable<any> {
    const body = JSON.stringify(applicationSchemePks);
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    return this
      .put(`api/applicationSchemes/updateCropPkFromCropInterceptionPk`, body, headers)
      .pipe(map((data: any) => data.Value));
  }
}
